module.exports = __webpack_public_path__ + "img/5.122cdd3f.jpg";